import React, { useEffect } from 'react';
import { fetchQuote } from './api/QuoteData';
import { fetchNewQuote } from './api/NewQuoteData';

const Content = () => {
	const [quote, setQuote] = React.useState({ text: 'Loading...', author: ' ' });

	// * This is to be called only one time when the website opens for the first time.
	useEffect(() => {
		const response = fetchQuote();
		response.then((data) => {
			console.log(data);
			setQuote(data);
		});
	}, []);

	// * This is to be called every time the button is clicked.
	const handleClick = () => {
		const response = fetchNewQuote();
		response.then((data) => {
			console.log(data);
			setQuote(data[0]);
		});
	};

	return (
		<div id="quote-box">
			<div id="text">{quote.text}</div>
			<div id="author">{quote.author}</div>
			<div id="buttons">
				<button id="new-quote" onClick={handleClick}>
					New Quote
				</button>
				<a
					id="tweet-quote"
					href={`https://twitter.com/compose/tweet?text=` + quote.text}
				>
					Tweet Quote
				</a>
			</div>
		</div>
	);
};

export default Content;
